import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, Legend } from 'recharts';
import { useIsMobile } from '@/hooks/use-mobile';

interface FunnelData {
  name: string;
  value: number;
  color: string;
}

interface CRMFunnelChartProps {
  data: FunnelData[];
}

export function CRMFunnelChart({ data }: CRMFunnelChartProps) {
  const isMobile = useIsMobile();
  
  return (
    <Card className="shadow-soft h-full">
      <CardHeader>
        <CardTitle className="text-base sm:text-lg">Funil de Vendas (CRM)</CardTitle>
        <CardDescription className="text-xs sm:text-sm">Distribuição de leads por etapa</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[200px] sm:h-[250px] md:h-[300px] w-full mt-4">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical"
              data={data}
              margin={{ 
                top: 5, 
                right: isMobile ? 10 : 30, 
                left: isMobile ? 60 : 40, 
                bottom: 5 
              }}
            >
              <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
              <XAxis type="number" hide />
              <YAxis 
                dataKey="name" 
                type="category" 
                tick={{ fontSize: isMobile ? 10 : 12 }} 
                width={isMobile ? 80 : 150}
              />
              <Tooltip 
                cursor={{ fill: 'transparent' }}
                content={({ active, payload }) => {
                  if (active && payload && payload.length) {
                    return (
                      <div className="bg-background border border-border p-2 rounded-md shadow-md text-xs">
                        <p className="font-bold">{payload[0].payload.name}</p>
                        <p>Quantidade: {payload[0].value}</p>
                      </div>
                    );
                  }
                  return null;
                }}
              />
              <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={isMobile ? 25 : 30}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}




